var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReachIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "tiny",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    id: "svg_1",
    strokeWidth: 0.5859375,
    r: 228.5,
    fill: "none",
    cy: 542,
    cx: 510.5,
    d: "M8.66 6.352A2.678 2.678 0 0 1 5.982 9.029A2.678 2.678 0 0 1 3.305 6.352A2.678 2.678 0 0 1 8.66 6.352z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    id: "svg_4",
    y2: 143,
    y1: 313,
    x2: 511,
    x1: 511,
    strokeWidth: 0.5859375,
    d: "M5.988 3.668L5.988 1.676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    strokeWidth: 0.5859375,
    stroke: "black",
    r: 50,
    fill: "none",
    cy: 76,
    cx: 508,
    d: "M6.539 0.891A0.586 0.586 0 0 1 5.953 1.477A0.586 0.586 0 0 1 5.367 0.891A0.586 0.586 0 0 1 6.539 0.891z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    id: "svg_6",
    y2: 290,
    y1: 403,
    x2: 808,
    x1: 690,
    strokeWidth: 0.5859375,
    d: "M8.086 4.723L9.469 3.398"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    strokeWidth: 0.5859375,
    stroke: "black",
    r: 50,
    fill: "none",
    cy: 250,
    cx: 850,
    d: "M10.547 2.93A0.586 0.586 0 0 1 9.961 3.516A0.586 0.586 0 0 1 9.375 2.93A0.586 0.586 0 0 1 10.547 2.93z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    id: "svg_8",
    y2: 546,
    y1: 546,
    x2: 900,
    x1: 749,
    strokeWidth: 0.5859375,
    d: "M8.777 6.398L10.547 6.398"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    strokeWidth: 0.5859375,
    stroke: "black",
    r: 50,
    fill: "none",
    cy: 539,
    cx: 947,
    d: "M11.684 6.316A0.586 0.586 0 0 1 11.098 6.902A0.586 0.586 0 0 1 10.512 6.316A0.586 0.586 0 0 1 11.684 6.316z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    id: "svg_10",
    y2: 878,
    y1: 726,
    x2: 818,
    x1: 665,
    strokeWidth: 0.5859375,
    d: "M7.793 8.508L9.586 10.289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    strokeWidth: 0.5859375,
    stroke: "black",
    r: 50,
    fill: "none",
    cy: 914,
    cx: 861,
    d: "M10.676 10.711A0.586 0.586 0 0 1 10.09 11.297A0.586 0.586 0 0 1 9.504 10.711A0.586 0.586 0 0 1 10.676 10.711z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    id: "svg_12",
    y2: 920,
    y1: 790,
    x2: 512,
    x1: 512,
    strokeWidth: 0.5859375,
    d: "M6 9.258L6 10.781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_13",
    strokeWidth: 0.5859375,
    stroke: "black",
    r: 50,
    fill: "none",
    cy: 947,
    cx: 515,
    d: "M6.621 11.098A0.586 0.586 0 0 1 6.035 11.684A0.586 0.586 0 0 1 5.449 11.098A0.586 0.586 0 0 1 6.621 11.098z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    id: "svg_14",
    y2: 892.99999,
    y1: 725,
    x2: 197,
    x1: 356,
    strokeWidth: 0.5859375,
    d: "M4.172 8.496L2.309 10.465"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_15",
    strokeWidth: 0.5859375,
    stroke: "black",
    r: 50,
    fill: "none",
    cy: 931,
    cx: 174,
    d: "M2.625 10.91A0.586 0.586 0 0 1 2.039 11.496A0.586 0.586 0 0 1 1.453 10.91A0.586 0.586 0 0 1 2.625 10.91z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    id: "svg_16",
    y2: 546,
    y1: 546,
    x2: 109.00001,
    x1: 275,
    strokeWidth: 0.5859375,
    d: "M3.223 6.398L1.277 6.398"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_17",
    strokeWidth: 0.5859375,
    stroke: "black",
    r: 50,
    fill: "none",
    cy: 549,
    cx: 76,
    d: "M1.477 6.434A0.586 0.586 0 0 1 0.891 7.02A0.586 0.586 0 0 1 0.305 6.434A0.586 0.586 0 0 1 1.477 6.434z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    id: "svg_18",
    y2: 286.24349,
    y1: 399.75651,
    x2: 211.72387,
    x1: 332.27612,
    strokeWidth: 0.5859375,
    d: "M3.894 4.685L2.481 3.354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_19",
    strokeWidth: 0.5859375,
    stroke: "black",
    r: 50,
    fill: "none",
    cy: 250,
    cx: 174,
    d: "M2.625 2.93A0.586 0.586 0 0 1 2.039 3.516A0.586 0.586 0 0 1 1.453 2.93A0.586 0.586 0 0 1 2.625 2.93z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    id: "svg_25",
    d: "M6.531 5.486s0.097 -0.468 0 -0.627c-0.097 -0.159 -0.135 -0.264 -0.348 -0.34s-0.135 -0.061 -0.29 -0.053c-0.155 0.008 -0.284 0.106 -0.284 0.158 0 0 -0.097 0.008 -0.135 0.053 -0.039 0.045 -0.103 0.257 -0.103 0.309s0.032 0.408 0.064 0.483l-0.038 0.015c-0.032 0.438 0.129 0.491 0.129 0.491 0.058 0.408 0.116 0.234 0.116 0.34s-0.058 0.068 -0.058 0.068 -0.051 0.166 -0.18 0.226c-0.129 0.06 -0.845 0.385 -0.903 0.453 -0.058 0.068 -0.052 0.385 -0.052 0.385h3.07s0.007 -0.317 -0.051 -0.385c-0.058 -0.068 -0.774 -0.393 -0.903 -0.453 -0.129 -0.06 -0.18 -0.226 -0.18 -0.226s-0.058 0.038 -0.058 -0.068 0.058 0.068 0.116 -0.34c0 0 0.161 -0.053 0.129 -0.491z",
    strokeWidth: 0.5859375,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReachIcon);
export default __webpack_public_path__ + "static/media/reach-icon.3c29c4112579abd10f4897190f8ddb66.svg";
export { ForwardRef as ReactComponent };